import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CuentasPorCobrarService } from '../../../../services/cuentas-por-cobrar.service';
import { ConstantsService } from '../../../../services/constants.service';

@Component({
    selector: 'app-listado-archivos',
    templateUrl: './listado-archivos.component.html',
    styleUrls: ['./listado-archivos.component.scss']
})
export class ListadoArchivosComponent implements OnInit {
    public categorias: any[] = [];
    public api_url: string = "";
    public loading: boolean = false;
    public errors: any = [];
    public tipos_arrendatario: any = [];
    public mostrar = false;

    @Input() public contrato: any = {};
    @Output() contratoGuardado: EventEmitter<any> = new EventEmitter;

    constructor(public cuentasPorCobrarService: CuentasPorCobrarService,
        public constantsService: ConstantsService) {
        this.api_url = constantsService.apiURL;
    }

    ngOnInit() {
        this.loadTiposArrendatario();
    }

    loadFiles() {
        this.categorias = [];
        for (var i = 0; i < this.contrato.archivos.length; i++) {
            var archivo = this.contrato.archivos[i];
            var archivos_categoria = this.getArchivosCategoria(archivo.categoria);
            archivos_categoria.push(archivo);
        }

    }

    getArchivosCategoria(cat) {
        for (var i = 0; i < this.categorias.length; i++) {
            var categoria = this.categorias[i];
            if (categoria.slug == cat) {
                return categoria.archivos;
            }
        }
        var archivos_categoria = [];
        this.categorias.push({ nombre: this.firstLetterUppercase(cat), slug: cat, archivos: archivos_categoria });
        return archivos_categoria;
    }

    firstLetterUppercase(string) {
        return string[0].toUpperCase() + string.slice(1);
    }

    eliminarOtroArchivo(index, archivo) {
        var parent = this;
        this.eliminarArchivoInput(archivo, function () {
            for (var i = 0; i < parent.contrato.otros_archivos.length; i++) {
                if (i == index) {
                    parent.contrato.otros_archivos.splice(i, 1);
                }
            }
        });
    }

    clickInput(input) {
        document.getElementById(input).click();
    }

    onFileSelect(archivo, $event) {
        if ($event.target.files.length > 0) {
            const file = $event.target.files[0];
            archivo.input_file = file;
            archivo.nombre_archivo = file.name;
            this.subirArchivo(archivo);
        }
    }

    subirArchivo(archivo) {
        archivo.loading = true;
        var id_contrato = this.contrato.id_contrato;
        this.cuentasPorCobrarService.subirArchivoContrato(id_contrato, archivo)
            .subscribe(
                (response) => {
                    let content = response.json().content;
                    var archivo_url = content.archivo_url;
                    var nombre_archivo = content.nombre_archivo;
                    this.actualizarArchivoEnContrato(archivo_url, nombre_archivo, archivo);
                    archivo.error = undefined;
                },
                (error) => {
                    archivo.loading = false;
                    archivo.input_file = undefined;
                    try {
                        archivo.error = JSON.parse(error._body).content.archivo;
                    } catch (e) {
                        archivo.error = "Error al subir documento. Es posible que el archivo sea demasiado grande (límite superado)";
                    }
                }
            );
    }

    actualizarArchivoEnContrato(ruta_archivo, nombre_archivo, archivo) {
        archivo.loading = true;
        var id_contrato = this.contrato.id_contrato;
        var id_tipo_contrato_archivo = archivo.id_tipo_contrato_archivo;
        this.cuentasPorCobrarService.actualizarArchivoContrato(id_contrato, id_tipo_contrato_archivo, ruta_archivo, nombre_archivo)
            .subscribe(
                (response) => {
                    archivo.input_file = undefined;
                    archivo.loading = false;
                    let content = response.json().content;
                    archivo.archivo_cargado = content;
                    //Este es para que se vea bien en "otros"
                    archivo.id_contrato_archivo = content.id_contrato_archivo;
                },
                (error) => {
                    archivo.loading = false;
                    alert(error.content.archivo);
                }
            );
    }


    eliminarArchivoInput(archivo, callback) {
        this.eliminarArchivoDeContrato(archivo);
        if (callback) {
            callback();
        }
    }

    eliminarArchivoDeContrato(archivo) {
        archivo.loading = true;
        var id_contrato_archivo = null;
        if (archivo.archivo_cargado) {
            id_contrato_archivo = archivo.archivo_cargado.id_contrato_archivo;
        } else {
            id_contrato_archivo = archivo.id_contrato_archivo;
        }
        this.cuentasPorCobrarService.eliminarArchivoDeContrato(this.contrato.id_contrato, id_contrato_archivo)
            .subscribe(
                (response) => {
                    archivo.loading = false;
                    archivo.input_file = undefined;
                    archivo.archivo_cargado = undefined;
                    archivo.id_contrato_archivo = undefined;
                },
                (error) => {
                    archivo.loading = false;
                    alert("ERROR:: " + JSON.stringify(error));
                }
            );
    }

    agregarOtroArchivo() {
        this.contrato.otros_archivos.push(
            {
                nombre_archivo: "Nuevo archivo",
                ruta_archivo: null
            }
        );
    }

    guardarContrato() {
        if (!this.validar()) return false;
        var parent = this;
        if (this.contratoGuardado) {
            this.contratoGuardado.emit(
                {
                    go_to_next_page: true,
                    contrato: this.contrato,
                    callback: function () {
                        parent.loading = false;
                    }
                });
        }
    }

    loadTiposArrendatario() {
        this.cuentasPorCobrarService.getTiposArrendatarios()
            .subscribe(response => {
                let content = response.json().content;
                this.tipos_arrendatario = content;
            });
    }

    obtenerSlugTipoArrendatario() {
        for (var i = 0; i < this.tipos_arrendatario.length; i++) {
            var tipo_arrendatario = this.tipos_arrendatario[i];
            if (this.contrato.proveedor.id_tipo_arrendatario == tipo_arrendatario.id_tipo_arrendatario) {
                return tipo_arrendatario.slug;
            }
        }

        return "";
    }

    validar() {
        var valid = true;
        //Se validan proveedores con validacion custom
        //console.log("this.contrato: ",this.contrato);
        if (this.contrato.proveedor.is_op == 1) {
            for (var i = 0; i < this.categorias.length; i++) {
                var cat = this.categorias[i];
                //console.log("cat:",cat);
                for (var j = 0; j < cat.archivos.length; j++) {
                    var a = cat.archivos[j];
                    if (!a.archivo_cargado && a.is_required_op) {          //(i == 0 && (j == 7 || j == 8))
                        a.error = "Archivo requerido";
                        valid = false;
                    } else {
                        a.error = null;
                    }

                }
            }
        } else {
            for (var i = 0; i < this.categorias.length; i++) {
                var cat = this.categorias[i];
                for (var j = 0; j < cat.archivos.length; j++) {
                    var a = cat.archivos[j];

                    if (!a.archivo_cargado) {
                        a.error = "Archivo requerido";
                        valid = false;
                    } else {
                        a.error = null;
                    }

                }
            }
        }

        return valid;
    }

    visualizar() {
        if (!this.mostrar) {
            this.mostrar = true;
        }
        else this.mostrar = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/contratos/agregar-contrato/listado-archivos/listado-archivos.component.ts